// WARNING: Exposed to frontend
export const buildSearchQuery = ({ roles, locations, skills }) => {
  const searchParams = new URLSearchParams({})

  if (roles) {
    searchParams.append('roles', roles.map(role => role.value).join(','))
  }

  if (locations) {
    searchParams.append('locations', locations.map(location => location.value).join(','))
  }

  if (skills) {
    searchParams.append('skills', skills.map(skill => skill.value).join(','))
  }

  return searchParams.toString()
}
